/* eslint-disable no-useless-escape */
import {
  FacebookIframe,
  FacebookUrlRegex1,
  FacebookUrlRegex2,
  InstagramIframe,
  InstagramUrlRegex,
  LoomIframe,
  LoomUrlRegex,
  TiktokUrlRegex,
  VimeoUrlRegex,
  WistiaUrlRegex,
  VidyardUrlRegex,
  VidyardIframe,
  DailymotionRegex,
  YouTubeRegex,
  DailymotionIframe
} from '../lib/constants';
import { VideoProvider } from '../lib/enums/videoProvider';
import { errorParser } from '../lib/response/errorParser';

export const actions = {
  isValidUrl({ commit }, { url, provider }) {
    const matchingUrls = getMatchingUrls(provider, url);
    if (!matchingUrls) return false;

    return true;
  },

  async generateYouTubeEmbedHtml({ commit }, { url }) {
    const matchingUrls = getMatchingUrls(VideoProvider.YouTube, url);

    if (!matchingUrls) return;

    const videoId = matchingUrls[1] || matchingUrls[2];
    const embedURL = `https://www.youtube.com/embed/${videoId}`;
    const escapedCode = embedURL.replace(/'/g, '&apos;');
    return `<iframe style="width:100%;height:unset;" src='${escapedCode}'></iframe>`;

    //TODO : Clear above and uncomment code below once we get the youtube API Key
    // iframe = await this.getYouTubeVideoInfo(videoId);
  },

  async generateTiktokEmbedHtml({ commit }, { url }) {
    try {
      const response = await this.$axios.$get('https://www.tiktok.com/oembed', {
        params: {
          url
        }
      });

      return response;
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  },

  async generateVimeoEmbedHtml({ commit }, { url }) {
    try {
      const response = await this.$axios.$get(
        'https://vimeo.com/api/oembed.json',
        {
          params: {
            url,
            width: 500,
            height: 500
          }
        }
      );

      return response;
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  },

  async generateDailymotionEmbedHtml({ commit }, { url }) {
    const id = url.substring(url.lastIndexOf('/') + 1);

    return DailymotionIframe.replaceAll('*ID*', id) ?? '';
  },

  async generateWistiaEmbedHtml({ commit }, { url }) {
    try {
      const response = await this.$axios.$get(
        'https://fast.wistia.com/oembed',
        {
          params: {
            url,
            embedType: 'iframe',
            width: 500,
            height: 500
          }
        }
      );

      return response;
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response.data
      };
    }
  },

  async generateVidyardEmbedHtml({ commit }, { url }) {
    const id = url.substring(
      url.lastIndexOf('/') + 1,
      url.endsWith('?') ? url.lastIndexOf('?') : url.length
    );

    return VidyardIframe.replaceAll('*ID*', id) ?? '';
  },

  async generateLoomEmbedHtml({ commit }, { url }) {
    const id = url.substr(url.lastIndexOf('/') + 1);

    return LoomIframe.replaceAll('*ID*', id) ?? '';
  },

  async generateFacebookEmbedHtml({ commit }, { url }) {
    return (
      FacebookIframe.replace(/'/g, '&apos;').replaceAll('*URL*', url) ?? ''
    );
  },

  async generateInstagramEmbedHtml({ commit }, { url }) {
    return InstagramIframe.replaceAll('*URL*', url) ?? '';
  }
};

function getMatchingUrls(provider: string, url: string) {
  switch (provider) {
    case VideoProvider.YouTube:
      return url.match(YouTubeRegex);

    case VideoProvider.Facebook:
      return url.match(FacebookUrlRegex1) || url.match(FacebookUrlRegex2);

    case VideoProvider.Instagram:
      return url.match(InstagramUrlRegex);

    case VideoProvider.Tiktok:
      return url.match(TiktokUrlRegex);

    case VideoProvider.Vimeo:
      return url.match(VimeoUrlRegex);

    case VideoProvider.Loom:
      return url.match(LoomUrlRegex);

    case VideoProvider.Wistia:
      return url.match(WistiaUrlRegex);

    case VideoProvider.Vidyard:
      return url.match(VidyardUrlRegex);

    case VideoProvider.Dailymotion:
      return url.match(DailymotionRegex);

    default:
      return false;
  }
}
